import React, { useState } from "react";
import { Cropper } from "../../Other/Cropper/Cropper";
import { Loading } from "../../Other/Loading";
import { useDispatch } from "react-redux";
import { userService } from "../../../_services";
import { userConstants } from "../../../_constants";
import axiosInstance from "../../../axios";

export const UploadAvatar = ({ hideUploadAvatar }) => {
  const dispatch = useDispatch();
  const [src, setSrc] = useState(null);
  const [loader, setLoader] = useState(false);

  const handleChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setSrc(URL.createObjectURL(event.target.files[0]));
    } else {
      hideUploadAvatar(false);
    }
  };

  const clickCancel = (event) => {
    event.preventDefault();
    hideUploadAvatar(false);
  };

  const uploadProfileImage = async (base64) => {
    if (base64) {
      setLoader(true);
      axiosInstance
        .post("user/profile/image", {
          base64: base64,
          fileName: "profile",
          fileExt: "png",
        })
        .then(() => {
          userService
            .getUserInfo()
            .then(({ data }) => {
              dispatch({
                type: userConstants.GET_USER_INFO,
                payload: data.data,
              });
            })
            .finally(() => {
              hideUploadAvatar(false);
              setLoader(false);
            });
        });
    }
  };

  return (
    <>
      {loader ? (
        <Loading />
      ) : (
        <div className="upload-avatar">
          {!src ? (
            <div className="upload-section">
              <h4 className="header">
                Accepted avatars formats are PNG, JPG, JPEG and GIF
              </h4>
              <div className="upload-icon">
                <input
                  id="avatar"
                  className=""
                  type="file"
                  value=""
                  onChange={handleChange}
                ></input>
              </div>
              <h4>Drag and drop or browse to choose a file</h4>
            </div>
          ) : (
            <div className="preview-section">
              <Cropper
                src={src}
                getBlob={uploadProfileImage}
                closeCropper={clickCancel}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
